'use client';

import React from 'react';

// Simple, fast loader for auth checks - completes almost instantly
export default function AuthLoader() {
  return (
    <div className="fixed inset-0 z-50 bg-white flex items-center justify-center">
      {/* Logo */}
      <div className="relative">
        <img 
          src="https://usbamprqshmoalvlkjch.supabase.co/storage/v1/object/public/branding/Inputperformanceaiwhite.png" 
          alt="Input" 
          className="h-16 w-auto animate-pulse"
        />
        
        {/* Spinning ring */}
        <div className="absolute inset-0 -m-3 flex items-center justify-center">
          <div className="w-24 h-24 rounded-full border-2 border-green-400/30 border-t-green-400 animate-spin" />
        </div>
      </div>
    </div>
  );
}
